export class ODataResponse<T> {
  public context: string = "";
  public count: number = 0;
  public value: T[] = [];

  constructor(response: any = null) {
    if (response) {
      this.context = response["@odata.context"];
      this.count = response["@odata.count"];
      this.value = response.value;
    }
  }
}